import { render, staticRenderFns } from "./ColumnText.vue.js?vue&type=template&id=a9d09366!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ColumnText.vue?vue&type=template&id=a9d09366"
import script from "./ColumnText.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ColumnText.vue?vue&type=script&lang=js"
export * from "./ColumnText.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ColumnText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports